export const styles = {
  section: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flexGrow: 1,
  },
  container: {
    width: "100%",
    padding: 0,
    margin: 0,
    position: "relative",
    flexGrow: 1,
    "@media (max-width: 900px)": {
      flexDirection: "column",
    },
  },
  image: {
    position: "absolute",
    right: "0px",
    zIndex: 9999,
  },
};
